/**
 * The "Submission rules" section of the feedback page (#415 item 2): the course's five format rules for handing in a sheet, one
 * line each, ✓ / ✗ / ○. It is separate from the maths and about the FORMAT, never about what the learner knows - no status, score or
 * count comes of it. The server decides every mark (`submission-rules@3`, deterministically, never by a model); a ○ says why it could
 * not be decided. The mark is always in words beside the symbol.
 */

import type { HomeworkFeedbackResponse } from '@davinci/contracts';
import { fillTemplate } from '../../i18n/fill-template.js';
import { useFeedbackLabels } from '../../i18n/homework-feedback-labels.js';

const SYMBOLS = { met: '✓', not_met: '✗', not_checked: '○' } as const;

export function SubmissionRules({ rules }: { readonly rules: NonNullable<HomeworkFeedbackResponse['submissionRules']> }): React.JSX.Element {
  const t = useFeedbackLabels();
  return (
    <section aria-labelledby="feedback-submission-rules">
      <h2 id="feedback-submission-rules">{t.submissionRulesHeading}</h2>
      <p>{t.submissionRulesIntro}</p>
      <ul className="plain-list">
        {rules.rules.map((rule) => (
          <li key={rule.ruleId}>
            <span aria-hidden="true">{SYMBOLS[rule.mark]}</span> {t.submissionRuleText(rule.ruleId)} <strong>{t.submissionRuleMark(rule.mark)}</strong>
            {rule.reason === undefined ? null : <span className="field-hint"> ({t.submissionRuleReason(rule.reason)})</span>}
          </li>
        ))}
      </ul>
      <p className="field-hint">{fillTemplate(t.submissionRulesPolicy, { policy: <code>{rules.policyVersion}</code> })}</p>
    </section>
  );
}
